var _KRP0008_COUPON = (function () {
    // prettier-ignore
    var couponItemTemplate = '<li data-coupon-id="{{encCpId}}">' +
        //  BTOCSITE-24569 {{_state}} => class명이 lge-before 일때 LGE.COM | member-ship 일때LG전자멤버십 뱃지가 나옴.
        // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 : role 추가 및 문구 추가
        '<div class="cp-box {{_b2bCouponClass}} {{_state}}">' +
        '<div class="cp-cont">' +
        '<p class="cp-badge">LGE.COM</p>'   +
        '<em class="title">{{_cpDiscVal}}<i class="unit">{{_cpDiscUnit}}</i></em>' +
        '<p class="description">{{cpDispName}}</p>' +
        '{{#if cpPartnerType==="LGE" || cpPartnerType==="AFF"}}<p class="emp-coupon">임직원 전용쿠폰</p>' +
        '{{#elsif cpPartnerType==="AFC"}}<p class="emp-coupon">복지몰 전용쿠폰</p>{{/if}}' +
        '<div class="info">' +
        '<p>{{#if isDownload==="N"}}{{_cpPublEdDay}}{{#else}}{{_cpPeriodEdDay}}{{/if}} 종료({{_leftDayCnt}}일전)</p>' +
        '</div>' +
        '<div class="cp-btn">' +
        '<button type="button" class="download" {{#if isDownload==="N"}} data-contents="{{cpDispName}}" {{/if}}>' +
        '<em>{{#if isDownload==="N"}}다운로드{{#else}}발급<br>완료{{/if}}</em>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<div class="cp-open-view">' +
        '<a href="#n" class="text" role="button">상세정보</a>' +
        '<div class="cp-cont-view" aria-expanded="">' +
        '<strong class="sub-tit">{{#if isDownload==="N"}}발급기간{{#else}}유효기간{{/if}}</strong>' +
        '<div class="sub-cont">{{#if isDownload==="N"}}{{_cpPublStDate}} 부터 <br>{{_cpPublEdDate}} 까지{{#else}}{{_cpPeriodStData}} 부터 <br>{{_cpPeriodEdData}} 까지{{/if}}</div>' +
        '{{#if cpDiscMinPrice !== "" }}' +
        '<strong class="sub-tit">할인조건</strong>' +
        '<div class="sub-cont">{{cpDiscMinPrice}}</div>' +
        '{{/if}}' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</li>';
    // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
    // BTOCSITE-24569
    var mbsCouponItemTemplate = '<li data-coupon-id="{{couponNo}}">' +
        '<div class="cp-box {{_b2bCouponClass}} member-ship">' +
        '<div class="cp-cont">' +
        '<em class="title">{{_cpDiscVal}}<i class="unit">{{_cpDiscUnit}}</i></em>' +
        '<p class="description">{{couponNm}}</p>' +
        '<div class="info">' +
        '<p>{{_cpPublEdDay}} 종료({{#if _leftDayCnt === 0 }}오늘{{#else}}{{_leftDayCnt}}일전{{/if}})</p>' +
        '</div>' +
        '<div class="cp-btn">' +
        '<button type="button" class="download">' +
        '<em>발급<br>완료</em>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<div class="cp-open-view">' +
        '<a href="#n" class="text">상세정보</a>' +
        '<div class="cp-cont-view">' +
        '<strong class="sub-tit">유효기간</strong>' +
        '<div class="sub-cont">{{_cpPublStDate}} 부터 <br>{{_cpPublEdDate}} 까지</div>' +
        '<strong class="sub-tit">사용처</strong>' +
        '<div class="sub-cont">LGE.COM, 베스트샵 (중복사용불가)</div>' +
        '<strong class="sub-tit">할인조건</strong>' +
        '<div class="sub-cont">적용 대상 : 일반 제품' +
        '{{#if _cpDiscMaxPrice !== "" }}<br>최대 할인 금액 : {{_cpDiscMaxPrice}}원 할인{{/if}}' +
        '{{#if _cpDiscMinPrice !== "" }}<br>최소 주문 금액 : {{_cpDiscMinPrice}}원 이상 주문 시<br>{{/if}}' +
        '</div>' +
        '<ul class="bullet-list">' +
        '<li class="b-txt">단일 상품/단일 수량에 대해서만 쿠폰 적용이 가능합니다.</li>' +
        '<li class="b-txt">LG전자 멤버십 쿠폰은 일부 상품(시그니쳐, 스탠바이비, 소모품 등)에 적용이 제한될 수 있습니다.</li>' +
        '<li class="b-txt">LG전자 멤버십 쿠폰은 발급일로부터 1년간 사용 가능합니다.</li>' +
        '<li class="b-txt">LGE.COM과 베스트샵 매장에서 사용 가능하나 중복사용은 불가합니다.</li>' +
        '</ul>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</li>';
    var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

    var isDev =
        location.href.indexOf("KRP0008-coupon.html") >= 0 ||
        location.href.indexOf("KRP0008-2.0.0.html") >= 0
            ? true
            : false;

    var pdpCoupon = {
        variable: {
            couponList: [],
            couponCnt: 0,
            mbsCouponList: [],
            mbsCouponCnt: 0,
            useMbsCouponCnt: 0,
            partnerPrice: 0, //BTOCSITE-48266
            partnerCouponList: [],
            partnerCouponCnt: 0,
            couponPriceDispFlag: false, // 하단 쿠폰할인가 노출 영역 제어
            partnerCouponPriceDispFlag: false,
            isEmployee: false,
            callType: 'init' // 최초:init, 임직원 요금 노출 탭:tab,  그 외 일반:b2c

        },
        el: {
            $couponWrap: null,
            $popCoupon: null,
            $popCouponList: null,
            $popCouponB2cArea: null,
            $popCouponPartnerArea: null,
            $couponPriceArea: null,
            $benefitPriceArea: null,
            $partnerCouponPriceArea: null,
        },
        selector: {
            couponWrap: ".lists.coupon-item",
            popCoupon: "#coupon-pop",
            popCouponB2cArea: "#coupon1",
            popCouponPartnerArea: "#coupon2",
            popCouponList: ".coupon-list",
            couponDetail: '.coupon-detail', //BTOCSITE-35421
        },
        setProperty: function () {
            var $pdpInfo = this.el.$pdpInfo;

            this.$couponWrap = $pdpInfo.find(this.selector.couponWrap);
            this.$popCoupon = $(this.selector.popCoupon);
            this.$popCouponList = this.$popCoupon.find(this.selector.popCouponList);
            this.$popCouponB2cArea = $(this.selector.popCouponB2cArea);
            this.$popCouponPartnerArea = $(this.selector.popCouponPartnerArea);
            this.$couponDetail = $(this.selector.couponDetail); //BTOCSITE-35421
            this.$couponPriceArea = $('#couponPrice, #b2cTabCouponPrice');
            this.$benefitPriceArea = $('#benefitPrice, #b2cTabBenefitPrice');
            this.$partnerCouponPriceArea = $('#employeeTabCouponPrice');
        },

        init: function (el) {
            this.variable.inpData = lgkorUI.getHiddenInputData(); //BTOCSITE-35421

            this.el.$pdpInfo = $(el);

            if (!this.el.$pdpInfo.length > 0) {
                return;
            }
            this.setProperty();

            //this.requestPdpCoupon(); // 쿠폰리스트 두번 호출하게 되어있어 주석처리

            this.bindEvents();

            //BTOCSITE-35421
            this.benefitAreaInit();

            /* BTOCSITE-15679 특정 파라미터를 가진 URL로 접근시 쿠폰 팝업 기능 개발 : 이벤트 종료 후 코드 정리 예정 */
            var pathname = $(location).attr('pathname');
            var evtParam = location.search;

            //BTOCSITE-48266 [상품] B2B OBS 구축
            if (lgkorUI.getHiddenInputData().b2cYN === 'Y') {
                if (pathname == '/beauty-devices/blp1' || pathname == '/beauty-devices/bbp1' || pathname == '/beauty-devices/bcp2a' || pathname == '/beauty-devices/bcp1a') {
                    this.renderBeautyCouponList();
                    if (evtParam != '?eventcode=beautyapp') {
                        this.requestPdpCoupon();
                    }
                } else {
                    this.requestPdpCoupon();
                }
            } else {
                //b2b 사업자 회원가 가져오기 : 로그인시
                if (lgkorUI.stringToBool(loginFlag)) {
                    this.getB2bBusinessPrice()
                }
            }
            //BTOCSITE-81509 웹접근성
            this.$popCouponList.find(".cp-box").find('.cp-cont-view').attr('aria-expanded',false)
        },
        bindEvents: function () {
            //상세 보기 토글
            $("body").on("click", ".cp-open-view > .text", function () {
                $(this).parents(".cp-box").toggleClass("active");
                //BTOCSITE-81509 웹접근성
                if($(this).parents(".cp-box").hasClass('active')){
                    $(this).parents(".cp-box").find('.cp-cont-view').attr('aria-expanded',true)
                }else{
                    $(this).parents(".cp-box").find('.cp-cont-view').attr('aria-expanded',false)
                }
            });

            this.$popCoupon.on("click", ".download", $.proxy(this.handler.clickBtnDownCoupon, this));
            this.$popCoupon.on("click", ".btn", $.proxy(this.handler.clickBtnDownAllCoupon, this));
        },
        handler: {
            /**
             * @callback clickBtnDownCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 다운로드 아이콘 클릭 시 다운로드 ]
             */
            clickBtnDownCoupon: function (e) {
                //BTOCSITE-48266 [상품] B2B OBS 구축 : 사업자전용 쿠폰은 class 명이 다름.
                if ($(e.currentTarget).closest(".cp-box").hasClass("lge-after")
                    || $(e.currentTarget).closest(".cp-box").hasClass("member-ship")
                    || $(e.currentTarget).closest(".cp-box").hasClass("business-after")) {
                    return;
                }
                var couponId = $(e.currentTarget).closest("li").attr("data-coupon-id");
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                    this.requestPdpGetCoupon(couponId);
                    $('[data-coupon-id = "' + couponId + '"]').find("button").attr("disabled", true); // BTOCSITE-45073 쿠폰 다운로드 더블클릭 방지
                }
            },
            /**
             * @callback clickBtnDownAllCoupon
             * @param {*} e
             * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 쿠폰모두받기 버튼 클릭 시 모두 다운로드 ]
             */
            clickBtnDownAllCoupon: function () {
                var unifyId = vcui.Cookie.get("UNIFY_ID");
                if (unifyId === "" && !isDev) {
                    this.goLogin();
                } else {
                    this.requestPdpGetAllCoupon();
                }
            },

            //BTOCSITE-35421 쿠폰 버튼 이벤트등록
            couponInit: function f(e) {

                // 쿠폰 다운로드 팝업에서 펼쳐져 있는 상세정보 영역 접기
                $.each($(this.selector.popCoupon).find('.cp-box'), function(index, value){
                    if($(value).hasClass('active')){
                        $(value).toggleClass("active");
                    }
                });
                // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
                let popupType = $(e.currentTarget).attr("data-member-type");

                if (typeof popupType !== 'undefined' && popupType === 'employee') { // 탭노출 & 임직원 가격
                    this.$popCoupon.addClass('copuon-pop-emp');
                    this.$popCoupon.find('div.ui_tab').show();
                    $('#employeeCouponPopup a').trigger('click');
                    this.variable.callType = 'tab';
                } else if (typeof popupType !== 'undefined' && popupType === 'b2c') { // 탭노출 & 일반가격
                    this.$popCoupon.addClass('copuon-pop-emp');
                    this.$popCoupon.find('div.ui_tab').show();
                    $('#b2cCouponPopup a').trigger('click');
                    this.variable.callType = 'tab';
                } else { // 탭비노출
                    if (this.$popCoupon.find('div.ui_tab').length > 0) {
                        this.$popCouponPartnerArea.remove();
                    }
                    $('#b2cCouponPopup a').trigger('click');
                    this.$popCoupon.find('div.ui_tab').remove();
                    this.variable.callType = 'b2c';
                }

                if (lgkorUI.stringToBool(loginFlag)) {
                    //로그인시 쿠폰 팝업 노출
                    $("#coupon-pop").vcModal("show");
                } else {
                    //비로그인시 로그인 유도
                    // this.goLogin();
                    location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
                }
            }
        },
        /**
         * @method requestPdpCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 쿠폰 리스트 ajax 호출 ]
         */
        requestPdpCoupon: function () {
            var thisObj = this;
            //var getRewardExcutedCheck = setInterval(function () {
                try {
                    //if (_KRP0008.KRP0008.isGetRewardExcuted) {
                        var partnerType = digitalData.userInfo.partnerType;
                        var ajaxUrl = '/mkt/api/coupon/retrievePdpPartnerTypeCouponList';
                        var param = {};

                        let resultJson;
                        thisObj.variable.isEmployee = partnerType == "LGE" || partnerType == "AFF" || partnerType == "AFC";

                        if (lgePdpSendData.subCategoryId && lgePdpSendData.subCategoryId !== "") {
                            param.catgCode = lgePdpSendData.subCategoryId;
                        } else {
                            param.catgCode = lgePdpSendData.categoryId;
                        }

                        param.prodCode = lgePdpSendData.sku;

                        var obsOriginalPrice = Number(digitalData.productInfo.obsOriginalPrice);
                        var obsMemberPrice = Number(digitalData.productInfo.obsMemberPrice);
                        var obsDiscountPrice = Number(digitalData.productInfo.obsDiscountPrice);

                        //BTOCSITE-35421 쿠폰영역 노출 여부
                        var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                        var modelGubun = '';
                        if (productInfo != null) {
                            modelGubun = productInfo.model_gubun;
                        }

                        var obsSellingPride = typeof digitalData.productInfo.obsSellingPrice !== 'undefined' ? digitalData.productInfo.obsSellingPrice : memberDiscountPrice;
                        var partnerPrice = Number(digitalData.productInfo.partnerPrice);
                        var partnerLastBenefitPrice = Number(digitalData.productInfo.partnerLastBenefitPrice);
                        var controlPrice =  Number(digitalData.productInfo.obsControlPrice);

                        param.mPrice = thisObj.variable.isEmployee ? obsSellingPride + ',' + partnerPrice : obsSellingPride;
                        param.isMultiPartnerType = thisObj.variable.isEmployee ? 'Y' : 'N';
                        param.partnerType = thisObj.variable.isEmployee ? 'B2C' + ',' + digitalData.productInfo.memberPartnerGrp : 'B2C';
                        param.partnerCd = thisObj.variable.isEmployee ? digitalData.userInfo.partnerCode : '';
                        param.controlPrice = controlPrice;

                        //BTOCSITE-48266 start
                        if(lgkorUI.getHiddenInputData().b2cYN === "N"){
                            param.partnerType = "ENT";
                            param.mPrice = pdpCoupon.variable.partnerPrice;
                        }
                        //BTOCSITE-48266 start
                        
                        //BTOCSITE-85864
        				var pcsYn = (location.search.indexOf("channel_code") > 0 || location.search.indexOf("naver_code") > 0)? "Y" : "N";
                        param.pcsYn = pcsYn;

                        $.ajax({
                            url: ajaxUrl,
                            method: "POST",
                            async: false,
                            data: JSON.stringify(param),
                            contentType: "application/json",
                            dataType: "json",
                            success: function (result) {
                                try {
                                    if (result.result === "S") {
                                        resultJson = param.isMultiPartnerType === "N" ? result : result.B2C;

                                        // 일반영역 쿠폰 설정
                                        if (resultJson.result === "S") {
                                            //success
                                            thisObj.variable.couponCnt = resultJson.total;
                                            thisObj.variable.couponList = resultJson.data.couponList;

                                            //var maxCpPrice = result.data.maxCpPrice;
                                            //var maxCpDiscRate = result.data.maxCpDiscRate;

                                            thisObj.renderCounponList();

                                            var newCouponePrice = ""; //쿠폰 할인가
                                            var newApprDateDiscountRate = 0; // 결제일 할인가
                                            if (typeof memberDiscountPrice !== 'undefined') {
                                                var $maxPrice = $('.price-detail-item .max-price').not('.employee-disp'); // 쿠폰 할인가
                                                // 쿠폰 명
                                                var $maxPriceCouponText = $('.coupon-detail-item .text span').not('.employee-disp');
                                                var $availableCpNmPriceCouponText = $('.coupon-detail-item2 .text span'); //BTOCSITE-24569 상품 쿠폰 없는 경우 ajax availableCpNm 추가

                                                var $maxPriceCouponPrice = $('.coupon-detail-item .content span').not('.employee-disp');//쿠폰 금액
                                                var $maxPriceCoupon = $('.price-detail-item.coupon-detail-item').not('.employee-disp');
                                                var $maxPriceCouponPopupLink = $('#couponPricePopupSelector, #tabCouponPricePopupSelector');
                                                var $memberPricePopupLink = $('#memberPricePopupSelector, #tabMemberPricePopupSelector');

                                                var $userCouponTotal = $('.total-coupon-payment'); // 하단 쿠폰할인가
                                                var $userCouponPrice = $('.total-coupon-payment .payment .price'); // 하단 쿠폰할인가
                                                var dataMaxPrice = resultJson.data.maxCpPrice;
                                                var dataMaxPriceNumber = dataMaxPrice.replaceAll(',', '');
                                                var maxPriceNumberNumber = Number(dataMaxPrice.replaceAll(',', ''));

                                                var dataUserCouponPrice = resultJson.data.userCpPrice;
                                                var dataUserCouponPriceNumber = dataUserCouponPrice.replaceAll(',', '');

                                                var userCouponPriceNumber = Number(dataUserCouponPriceNumber);

                                                // 로그인 후 회원의 보유 쿠폰이 상이할 수 있으므로 최대혜택가 및 쿠폰할인가 팝업 내 데이터 업데이트를 위함
                                                let $memCouponPopup = $('#couponPricePopup .discount-price') // 쿠폰 할인가 팝업 쿠폰 노출 영역
                                                let $memCouponPopupPrice = $('#couponPricePopup .won.discount-appr') // 쿠폰 할인가 팝업 할인결제가 노출 영역
                                                let $memBenefitPopup = $('#maxBenefitPopup') // 최대혜택가 팝업
                                                let $memBenefitPopup2 = $('#maxBenefitPopup2') // 최대혜택가 팝업2

                                                //쿠폰 로직 개선
                                                //BTOCSITE-48266 : b2b 쿠폰가 수정
                                                var userCpBuyMaxQty = !vcui.isEmpty(resultJson.data.userCpBuyMaxQty) ? vcui.number.parse(resultJson.data.userCpBuyMaxQty) : 0;//number
                                                $('.total-coupon-payment .payment').data("cp-max-qty", userCpBuyMaxQty);


                                                // BTOCSITE-48266
                                                if (lgkorUI.getHiddenInputData().b2cYN === 'N') {
                                                    // B2B 쿠폰할인가 = 사업자회원가 - 쿠폰할인가격
                                                    var businessPrice = vcui.number.parse(pdpCoupon.variable.partnerPrice);

                                                    // 로그인 후 쿠폰 할인가 적용
                                                    if (dataMaxPrice && maxPriceNumberNumber > 0) {
                                                        if (businessPrice > 0) {
                                                            $maxPrice.text(vcui.number.addComma((businessPrice - vcui.number.parse(dataMaxPriceNumber)) + '원'));
                                                        } else {
                                                            $maxPrice.text(vcui.number.addComma((vcui.number.parse(dataMaxPriceNumber)) + '원'));
                                                        }

                                                        $maxPriceCouponText.text(resultJson.data.maxCpNm);
                                                        $availableCpNmPriceCouponText.text(resultJson.data.availableCpNm); //BTOCSITE-24569 상품 쿠폰 없는 경우 ajax availableCpNm 추가
                                                        $maxPriceCouponPrice.text('-' + dataMaxPrice + '원');
                                                        //$maxPrice.closest('li').show();
                                                        thisObj.$couponPriceArea.show();
                                                        $maxPriceCoupon.show();
                                                    } else if (resultJson.data != null && resultJson.data.couponList.length > 0) {
                                                        thisObj.$couponPriceArea.hide();// 쿠폰할인가
                                                        $('.price-detail-item.coupon-detail-item .price-info').not('.employee-disp').hide();
                                                        $('#couponDiscountPrice').hide();
                                                        $maxPriceCoupon.show();
                                                    }

                                                    // 로그인 후 하단 쿠폰 할인가
                                                    if (dataUserCouponPrice && userCouponPriceNumber > 0) {
                                                        $userCouponPrice.data('price', businessPrice - vcui.number.parse(dataUserCouponPriceNumber));
                                                        $userCouponPrice.html('<em>' + vcui.number.addComma((businessPrice - vcui.number.parse(dataUserCouponPriceNumber)) + '</em>원'));
                                                        $userCouponTotal.show();
                                                    } else {
                                                        $userCouponPrice.data('price', businessPrice);
                                                    }
                                                } else {
                                                    if (modelGubun !== "일반제품" && modelGubun !== "케어솔루션") {
                                                        // 비로그인 시
                                                        if (!lgkorUI.stringToBool(loginFlag)) {
                                                            $('.price-detail-item .before-login').closest('li').show();
                                                            return;
                                                        }
                                                    }

                                                    // 로그인 후 쿠폰 할인가 적용
                                                    if (dataMaxPrice && maxPriceNumberNumber > 0) {
                                                        $maxPrice.text(vcui.number.addComma((memberDiscountPrice - Number(dataMaxPriceNumber)) + '원'));
                                                        $maxPriceCouponText.text(resultJson.data.maxCpNm);
                                                        $availableCpNmPriceCouponText.text(resultJson.data.availableCpNm); //BTOCSITE-24569 상품 쿠폰 없는 경우 ajax availableCpNm 추가
                                                        $maxPriceCouponPrice.text('-' + dataMaxPrice + '원');
                                                        $maxPrice.closest('li').show();
                                                        $maxPriceCoupon.show();

                                                        if (modelGubun !== "소모품") {
                                                            // 쿠폰할인가 팝업 업데이트
                                                            let discountText = '쿠폰 할인';
                                                            let dataMaxCpRate = vcui.number.parse(resultJson.data.maxCpDiscRate);
                                                            if (dataMaxCpRate > 0) {
                                                                discountText += ' ' + dataMaxCpRate + '%';
                                                            }
                                                            $memCouponPopup.find('.txt.coupon-discount').text(discountText);
                                                            $memCouponPopup.find('.won.coupon-discount').text('-' + dataMaxPrice + '원');
                                                            $memCouponPopupPrice.text(vcui.number.addComma((memberDiscountPrice - Number(dataMaxPriceNumber)) + '원'));

                                                            // 최대혜택가 팝업 내 쿠폰할인 & 할인결제가 업데이트
                                                            $memBenefitPopup.find('.coupon-discount .txt').text(discountText);
                                                            $memBenefitPopup.find('.coupon-discount .won').text('-' + dataMaxPrice + '원');
                                                            $memBenefitPopup.find('.coupon-discount').show();
                                                            $memBenefitPopup.find('.coupon-discount-price').text(vcui.number.addComma((memberDiscountPrice - Number(dataMaxPriceNumber)) + '원'));
                                                        }
                                                    }

                                                    // 로그인 후 하단 쿠폰 할인가
                                                    if (dataUserCouponPrice && userCouponPriceNumber > 0) {
                                                        $userCouponPrice.data('price', memberDiscountPrice - Number(dataUserCouponPriceNumber));
                                                        $userCouponPrice.html('<em>' +vcui.number.addComma((memberDiscountPrice - Number(dataUserCouponPriceNumber)) + '</em>원'));
                                                        if (modelGubun == "소모품") {
                                                            $('#couponDiscountArea').show();
                                                        }
                                                        $userCouponPrice.data('set-coupon-discount-price','Y');
                                                        // $userCouponTotal.show();
                                                        thisObj.variable.couponPriceDispFlag = 'Y';
                                                    } else {
                                                        $userCouponPrice.data('price', memberDiscountPrice);
                                                    }

                                                    //BTOCSITE-35421 로그인 후 최대 혜택 재 계산
                                                    if (modelGubun == "일반제품" || modelGubun == "케어솔루션") {

                                                        if (resultJson.data != null && resultJson.data.couponList.length > 0) {
                                                            if (maxPriceNumberNumber > 0) {
                                                                var $discountPayment = $('.view-discount-details .details-box .discount-payment'); // 할인결제가 영역
                                                                var $benefitPrice = $('.view-discount-details .details-box .maximum-benefit-price'); // 최대혜택가 영역

                                                                $('.view-discount-details').show(); //할인/혜택 내용보기 영역
                                                                $discountPayment.show(); //// 할인/혜택 내용보기 > 할인결제가 영역

                                                                thisObj.$couponPriceArea.show();// 쿠폰할인가
                                                                $('.coupon-detail-item').not('.employee-disp').show(); // 쿠폰정보
                                                                $('#couponDiscountPrice').show();// 할인/혜택 내용보기 > 쿠폰할인

                                                                /*
                                                                if(vcui.number.parse(result.data.maxCpDiscRate) > 0){
                                                                    $('#couponPrice').show(); // 쿠폰할인가
                                                                    $('.coupon-detail-item').show();// 쿠폰정보
                                                                    $('#couponDiscountPrice').show();// 할인/혜택 내용보기 > 쿠폰할인
                                                                }else{
                                                                    $('#couponPrice').hide(); // 쿠폰할인가
                                                                    $('.coupon-detail-item').hide(); // 쿠폰정보
                                                                    $('#couponDiscountPrice').hide(); // 할인/혜택 내용보기 > 쿠폰할인
                                                                }
                                                                */

                                                                var inputdata = thisObj.variable.inpData;

                                                                // 결제 한도
                                                                var apprDateDiscountLimitPrice = !vcui.isEmpty(inputdata.apprDateDiscountLimitPrice) && inputdata.apprDateDiscountLimitPrice !== "0" ? vcui.number.parse(inputdata.apprDateDiscountLimitPrice) : 0;
                                                                // 할인 결제가
                                                                var discountApprPrice = !vcui.isEmpty(inputdata.discountApprPrice) && inputdata.discountApprPrice !== "0" ? vcui.number.parse(inputdata.discountApprPrice) : 0;
                                                                // 결제일할인율
                                                                var apprDateDiscountRate = !vcui.isEmpty(inputdata.apprDateDiscountRate) && inputdata.apprDateDiscountRate !== "0" ? vcui.number.parse(inputdata.apprDateDiscountRate) : 0;
                                                                // 판매가
                                                                var obsSellingPrice = !vcui.isEmpty(inputdata.obsSellingPrice) && inputdata.obsSellingPrice !== "0" ? vcui.number.parse(inputdata.obsSellingPrice) : 0;
                                                                // 캐시백
                                                                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt) && inputdata.rewardAmt !== "0" ? vcui.number.parse(inputdata.rewardAmt) : 0;
                                                                //쿠폰 할인가
                                                                newCouponePrice = vcui.number.parse(dataMaxPrice.replaceAll(',', ''));
                                                                // 회원 할인
                                                                var obsMemberPrice = !vcui.isEmpty(inputdata.obsMemberPrice) && inputdata.obsMemberPrice !== "0" ? vcui.number.parse(inputdata.obsMemberPrice) : 0;
                                                                // 추가 할인
                                                                var obsDiscountPrice = !vcui.isEmpty(inputdata.obsDiscountPrice) && inputdata.obsDiscountPrice !== "0" ? vcui.number.parse(inputdata.obsDiscountPrice) : 0;

                                                                //쿠폰 할인가 set
                                                                $discountPayment.find(".coupon").find(".content span").text('-' + dataMaxPrice + '원');
                                                                //쿠폰 할인율
                                                                var dataMaxRate = vcui.number.parse(resultJson.data.maxCpDiscRate);
                                                                if (dataMaxRate > 0) {
                                                                    $('#couponDiscountRate').text(dataMaxRate + '%');
                                                                } else {
                                                                    $('#couponDiscountRate').text('');
                                                                }

                                                                var newDiscountApprPrice = obsSellingPrice - newCouponePrice; // 할인 결제가
                                                                var discountRatePrice = newDiscountApprPrice * (apprDateDiscountRate / 100);

                                                                if ((newDiscountApprPrice >= 500000 && (obsMemberPrice > 0 || obsDiscountPrice > 0)) || productInfo.model_id == 'MD10250832') {
                                                                    newApprDateDiscountRate = discountRatePrice > apprDateDiscountLimitPrice ? apprDateDiscountLimitPrice : Math.floor(discountRatePrice / 100) * 100; // 결제일 할인가
                                                                }
                                                                var newObsLastBenefitPrice = newDiscountApprPrice - rewardAmt - newApprDateDiscountRate; //최대혜택가

                                                                if ((rewardAmt > 0 || newApprDateDiscountRate > 0) || productInfo.model_id == 'MD10250832') {
                                                                    // 최대혜택가 노출 시 쿠폰할인가 팝업 제거 처리
                                                                    $maxPriceCouponPopupLink.removeAttr('href');
                                                                    $maxPriceCouponPopupLink.removeClass('link-text');
                                                                    $maxPriceCouponPopupLink.off('click');

                                                                    // 최대혜택가 팝업 업데이트
                                                                    // 캐시백
                                                                    if (rewardAmt > 0) {
                                                                        $memBenefitPopup.find('.cash-back .won').text('-' + vcui.number.addComma(rewardAmt) + '원');
                                                                        $memBenefitPopup2.find('.cash-back .won').text('-' + vcui.number.addComma(rewardAmt) + '원');
                                                                        $memBenefitPopup.find('.cash-back').show();
                                                                    }
                                                                    // 결제일할인
                                                                    if (apprDateDiscountRate > 0) {
                                                                        $memBenefitPopup.find('.appr-date-discount .txt').text('결제일 할인 ' + apprDateDiscountRate + '% (최대)');
                                                                        $memBenefitPopup.find('.appr-date-discount .won').text('-' + vcui.number.addComma(newApprDateDiscountRate) + '원');
                                                                        $memBenefitPopup.find('.appr-date-discount').show();
                                                                    }
                                                                    // 최대혜택가
                                                                    $memBenefitPopup.find('.max-benefit-price .won').text(vcui.number.addComma(newObsLastBenefitPrice) + '원');
                                                                    $memBenefitPopup2.find('.max-benefit-price .won').text(vcui.number.addComma(newObsLastBenefitPrice) + '원');
                                                                    // 최대혜택가 팝업 변경
                                                                    if (discountApprPrice === 0) {
                                                                        $('#tabMaxBenefitPopupSelector').on('click',function(e){
                                                                            e.preventDefault();
                                                                            $('#maxBenefitPopup2').vcModal({opener: this});
                                                                        });
                                                                    }

                                                                    //가격정보 영역 > 최대혜택가
                                                                    thisObj.$benefitPriceArea.show();
                                                                    thisObj.$benefitPriceArea.find('.content').find('.price').text(vcui.number.addComma(newObsLastBenefitPrice) + '원');

                                                                    //할인/혜택 내용보기 > 최대 혜택가
                                                                    $('.maximum-benefit-price').show();
                                                                    $benefitPrice.find(".payment").find(".content span").text(vcui.number.addComma(newObsLastBenefitPrice) + '원');

                                                                    //할인/혜택 내용보기 > 결제일 할인
                                                                    if (newApprDateDiscountRate > 0 || productInfo.model_id == 'MD10250832') {
                                                                        $('.maximum-benefit-price .day').show();  // 할인/혜택 내용보기 > 결제일 할인영역
                                                                        $benefitPrice.find(".day").find(".content span").text('-' + vcui.number.addComma(newApprDateDiscountRate) + '원');
                                                                    } else {
                                                                        $('.maximum-benefit-price .day').hide();
                                                                    }

                                                                } else {
                                                                    thisObj.$benefitPriceArea.hide();
                                                                    $('.maximum-benefit-price').hide();
                                                                    
                                                                    // 쿠폰할인가 팝업 노출
                                                                    $maxPriceCouponPopupLink.attr('href','#');
                                                                    $maxPriceCouponPopupLink.addClass('link-text');
                                                                    $maxPriceCouponPopupLink.on('click',function(e){
                                                                        e.preventDefault();
                                                                        $('#couponPricePopup').vcModal({opener: this});
                                                                    });
                                                                }

                                                                //할인/혜택 내용보기 영역 > 할인결제가 영역
                                                                if (newDiscountApprPrice > 0) {
                                                                    $discountPayment.find(".payment").find(".content span").text(vcui.number.addComma(newDiscountApprPrice) + '원');
                                                                }

                                                                // 일반회원 쿠폰할인가 영역 노출되는 경우 회원할인가 링크 제거 및 CSS 적용
                                                                $memberPricePopupLink.removeAttr('href');
                                                                $memberPricePopupLink.removeClass('link-text');
                                                                $memberPricePopupLink.off('click');
                                                                if (!$("#couponPrice").hasClass('price-detail-item2')) $("#couponPrice").addClass("price-detail-item2");
                                                                if (!$("#b2cTabCouponPrice").hasClass('price-detail-item2')) $("#b2cTabCouponPrice").addClass("price-detail-item2");

                                                            } else {
                                                                thisObj.$couponPriceArea.hide();// 쿠폰할인가
                                                                $('.price-detail-item.coupon-detail-item').not('.employee-disp').show();
                                                                $('.price-detail-item.coupon-detail-item .price-info').not('.employee-disp').hide();
                                                                $('#couponDiscountPrice').hide(); // 할인 / 혜택 내용보기 > 쿠폰할인
                                                            }
                                                        } else {
                                                            thisObj.$couponPriceArea.hide();// 쿠폰할인가
                                                            $('.coupon-detail-item').not('.employee-disp').hide();// 쿠폰정보
                                                            $('#couponDiscountPrice').hide(); // 할인 / 혜택 내용보기 > 쿠폰할인
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
                                        if (thisObj.variable.isEmployee && typeof partnerPrice !== 'undefined' && partnerPrice > 0 && !lgePdpSendData.isTimeDeal) {
                                            if (result[partnerType].result === "S") {
                                                resultJson = result[partnerType];
                                                //success
                                                thisObj.variable.partnerCouponCnt = resultJson.total;
                                                thisObj.variable.partnerCouponList = resultJson.data.couponList;

                                                thisObj.renderPartnerCounponList();

                                                var $maxPrice = $('.price-detail-item2 .max-price.employee-disp'); // 쿠폰 할인가
                                                var $maxPriceCoupon = $('.price-detail-item.coupon-detail-item.employee-disp'); // 쿠폰 적용 내역
                                                var $maxPriceCouponText = $('.coupon-detail-item .text span.employee-disp'); // 쿠폰 명
                                                var $maxPriceCouponPrice = $('.coupon-detail-item .content span.employee-disp');// 쿠폰 금액
                                                var $partnerCouponTotal = $('.emp-price-info.is-coupon-price-calc-new'); // 총금액 하단 임직원 쿠폰 할인가 영역
                                                var $partnerCouponPrice = $('.emp-price-info.is-coupon-price-calc-new .payment .price');

                                                var $couponPopup = $('#employeeTabCouponPricePopup .discount-price') // 쿠폰 할인가 팝업 쿠폰 노출 영역
                                                var $couponPopupPrice = $('#employeeTabCouponPricePopup .max-benefit-price') // 쿠폰 할인가 팝업 할인결제가 노출 영역
                                                var $benefitPopup = $('#employeeTabMaxBenefitPopup .coupon-discount') // 최대혜택가 팝업 쿠폰 할인 노출 영역
                                                var $benefitPopupPrice = $('#employeeTabMaxBenefitPopup .coupon-discount-price') // 최대혜택가 팝업 쿠폰 할인결제가 노출 영역
                                                var $partnerLastBenefitPricePopupArea = $('#employeeTabMaxBenefitPopup .last-benefit-price'); /// 최대혜택가 팝업 내 최대혜택가
                                                var $maxBenefitPrice = $('#employeeTabBenefitPrice .content .maxBenefitPrice'); // 바닥페이지 최대혜택가

                                                var dataMaxPrice = resultJson.data.maxCpPrice;
                                                var dataMaxRate = vcui.number.parse(resultJson.data.maxCpDiscRate);
                                                var dataMaxPriceNumber = dataMaxPrice.replaceAll(',', '');
                                                var maxPriceNumberNumber = Number(dataMaxPrice.replaceAll(',', ''));
                                                var dataUserCouponPrice = resultJson.data.userCpPrice;
                                                var dataUserCouponPriceNumber = dataUserCouponPrice.replaceAll(',', '');
                                                var couponSumPrice = (partnerPrice - Number(dataMaxPriceNumber)) < 0 ? 0 : (partnerPrice - Number(dataMaxPriceNumber));
                                                var lastBenefitPriceDisp = vcui.number.addComma(partnerLastBenefitPrice);

                                                var maxCpBuyMaxQty = !vcui.isEmpty(resultJson.data.maxCpBuyMaxQty) ? vcui.number.parse(resultJson.data.maxCpBuyMaxQty) : 0;//number
                                                var userCpBuyMaxQty = !vcui.isEmpty(resultJson.data.userCpBuyMaxQty) ? vcui.number.parse(resultJson.data.userCpBuyMaxQty) : 0;//number
                                                $partnerCouponTotal.find('.payment').data("cp-max-qty", userCpBuyMaxQty);

                                                if ($("#employeeCouponTotalPriceArea")) {
                                                    $("#employeeCouponTotalPriceArea").find(".payment").data("cp-max-qty", maxCpBuyMaxQty);
                                                }

                                                // 로그인 후 쿠폰 할인가 적용
                                                if (dataMaxPrice && maxPriceNumberNumber > 0) {
                                                    $maxPrice.html('<em>' + vcui.number.addComma(couponSumPrice + '</em>원'));

                                                    if (dataMaxRate == null) {
                                                        dataMaxRate = vcui.number.parse(resultJson.data.maxCpDiscRate);
                                                    }
                                                    let discountText = '쿠폰 할인';
                                                    if (dataMaxRate > 0) {
                                                        discountText += ' ' + dataMaxRate + '%';
                                                    }
                                                    $couponPopup.find('.txt').text(discountText);
                                                    $couponPopup.find('.won').text('-' + dataMaxPrice + '원');
                                                    $couponPopupPrice.find('.won').text(vcui.number.addComma(couponSumPrice + '원'));

                                                    $benefitPopup.find('.txt').text(discountText);
                                                    $benefitPopup.find('.won').text('-' + dataMaxPrice + '원');
                                                    $benefitPopupPrice.find('.won').text(vcui.number.addComma(couponSumPrice + '원'));

                                                    $benefitPopup.show();
                                                    $benefitPopupPrice.show();

                                                    if (modelGubun == "소모품") {
                                                        var $couponPopupTop = $('#employeeTabCouponPricePopup .price') // 쿠폰 할인가 팝업 쿠폰 노출 영역
                                                        $couponPopupTop.find('.won').text(vcui.number.addComma(partnerPrice + '원'));
                                                    }

                                                    $maxPriceCouponText.text(resultJson.data.maxCpNm);
                                                    $maxPriceCouponPrice.text('-' + dataMaxPrice + '원');
                                                    $maxPrice.closest('li').show(); // $('#employeeTabCouponPrice').show();
                                                    $maxPriceCoupon.show();

                                                    $partnerLastBenefitPricePopupArea.text(lastBenefitPriceDisp + '원');
                                                    $maxBenefitPrice.html('<em>' + lastBenefitPriceDisp + '</em>원');
                                                    $maxBenefitPrice.data('coupon-add-price', 'Y');
                                                }

                                                var dataUserCouponPrice = resultJson.data.userCpPrice;
                                                var dataUserCouponPriceNumber = dataUserCouponPrice.replaceAll(',', '');
                                                var userCouponPriceNumber = Number(dataUserCouponPriceNumber);

                                                // 로그인 후 하단 쿠폰 할인가
                                                if (dataUserCouponPrice && userCouponPriceNumber > 0) {
                                                    let totalCouponPrice = partnerPrice - Number(dataUserCouponPriceNumber);
                                                    $partnerCouponTotal.data('set-coupon-discount-price', 'Y');
                                                    $partnerCouponPrice.data('price', totalCouponPrice);
                                                    $partnerCouponPrice.html('<em>' + vcui.number.addComma(totalCouponPrice) + '</em>원');
                                                    // $partnerCouponTotal.show();
                                                    thisObj.variable.partnerCouponPriceDispFlag = 'Y';
                                                } else {
                                                    $partnerCouponPrice.data('price', partnerPrice);
                                                }
                                            }
                                        }
                                    }

                                    // 유형에 따라 바텀 영역 임직원/일반 쿠폰할인가 노출 여부를 처리함
                                    if (lgkorUI.getHiddenInputData().b2cYN === 'Y') {
                                        // 초기 호출
                                        if (thisObj.variable.callType == 'init') {
                                            if (thisObj.variable.partnerCouponPriceDispFlag == 'Y') {
                                                $('.emp-price-info.is-coupon-price-calc-new').show();
                                            }
                                            // } else if (thisObj.variable.couponPriceDispFlag == 'Y') {
                                            //     $('.total-coupon-payment').show();
                                            // }
                                            if (thisObj.variable.couponPriceDispFlag == 'Y') {
                                                $('.total-coupon-payment').show();
                                            }
                                            if(modelGubun == "소모품" && $('#employeeTab').hasClass('on')){
                                                if(partnerPrice > 0){
                                                    $('.emp-price-info.is-price-calc-new').show();
                                                    $('.total-coupon-payment').hide();
                                                }
                                            }
                                        // 임직원 가격탭 내 호출, 선택탭과 동일한 영역 노출 필요 시에만 처리
                                        } else if (thisObj.variable.callType == 'tab') {
                                            if (thisObj.variable.partnerCouponPriceDispFlag == 'Y' && $('#employeeTab').hasClass('on')) {
                                                $('.emp-price-info.is-coupon-price-calc-new').show();
                                                $('.total-coupon-payment').hide();
                                            } else if (thisObj.variable.couponPriceDispFlag == 'Y' && $('#b2cTab').hasClass('on')) {
                                                $('.total-coupon-payment').show();
                                                $('.emp-price-info.is-coupon-price-calc-new').hide();
                                            }
                                        // 일반
                                        } else if (thisObj.variable.callType == 'b2c' && thisObj.variable.couponPriceDispFlag == 'Y') {
                                            $('.total-coupon-payment').show();
                                        }
                                    }

                                    // 일반 & 임직원 쿠폰 전체 세팅 종료 후 호출
                                    thisObj.beforeloginCouponeInit(newCouponePrice, newApprDateDiscountRate);
                                    //BTOCSITE-24965 멤버십쿠폰 추가
                                    thisObj.requestPdpMeberShipCoupon();
                                } catch (e) {
                                    console.log(e);

                                    thisObj.beforeloginCouponeInit(newCouponePrice, newApprDateDiscountRate);
                                    //BTOCSITE-24965 멤버십쿠폰 추가
                                    thisObj.requestPdpMeberShipCoupon();
                                }
                                updateNewestPrice() // BTOCSITE-70412
                                //clearInterval(getRewardExcutedCheck);
                            },
                            error: function (error) {
                                console.log(error);
                                //clearInterval(getRewardExcutedCheck);
                            }
                        });

                        if (lgkorUI.getHiddenInputData().b2cYN === 'Y' && modelGubun !== "소모품") {
                            // 최대혜택가 팝업 내 캐시백, 결제일할인 노출 여부 확인
                            var rewardAmt = !vcui.isEmpty(thisObj.variable.inpData.rewardAmt) && thisObj.variable.inpData.rewardAmt !== "0" ? vcui.number.parse(thisObj.variable.inpData.rewardAmt) : 0;
                            var apprDateDiscountRate = !vcui.isEmpty(thisObj.variable.inpData.apprDateDiscountRate) && thisObj.variable.inpData.apprDateDiscountRate !== "0" ? vcui.number.parse(thisObj.variable.inpData.apprDateDiscountRate) : 0;

                            // 캐시백
                            if (rewardAmt > 0) {
                                $('#maxBenefitPopup').find('.cash-back').show();
                            }
                            // 결제일할인
                            if (apprDateDiscountRate > 0) {
                                $('#maxBenefitPopup').find('.appr-date-discount').show();
                            }
                        }
                    //}
                } catch (e) {
                    //clearInterval(getRewardExcutedCheck);
                }
            //}, 100);


            //BTOCSITE-48266 start
            // if(lgkorUI.getHiddenInputData().b2cYN === "Y"){
            //     param.partnerType = memPartnerType;
            //     if(typeof memberDiscountPrice !== 'undefined') {
            //         param.mPrice = memberDiscountPrice;
            //     }
            //
            //     // 임직원인 경우 partnerType, mPrice 추가
            //     if (digitalData.userInfo.partnerType == "LGE" || digitalData.userInfo.partnerType == "AFF" || digitalData.userInfo.partnerType == "AFC") {
            //         memPartnerType = digitalData.userInfo.partnerType;
            //         param.isMultiPartnerType = "Y";
            //         param.partnerType += ',' + memPartnerType;
            //         param.mPrice += ',' + memberDiscountPrice; /////////// 임직원 요금 확인
            //     }
            // }else{
            //     param.partnerType = "ENT";
            //     param.mPrice = pdpCoupon.variable.partnerPrice;
            // }
            //BTOCSITE-48266 start

        },
        /**
         * @method requestPdpGetCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 쿠폰 받기 ajax 호출 ]
         */
        requestPdpGetCoupon: function (couponId) {
            var ajaxUrl = this.el.$pdpInfo.attr("data-coupon-get-ajax");
            var param = {};
            param.couponId = couponId;
            param.userId = vcui.Cookie.get("UNIFY_ID");

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                    console.log(result)
                    // if (result.result === "S") {
                    if (result.resultCode === "success") {
                        //success
                        var obj = {title: ""};
                        obj = $.extend(obj, {title: result.message});
                        lgkorUI.alert(null, obj);

                        this.requestPdpCoupon();
                    } else {
                        //fail
                        var obj = {title: ""};
                        obj = $.extend(obj, {title: result.errorMsg});
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method requestPdpGetAllCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 쿠폰 모두 받기 ajax 호출 ]
         */
        requestPdpGetAllCoupon: function () {
            var ajaxUrl = this.el.$pdpInfo.attr("data-coupon-get-all-ajax");

            var oCouponId = [];

            //BTOCSITE-48266 [상품] B2B OBS 구축 : 사업자전용 쿠폰은 class 명이 다름.
            if (lgkorUI.getHiddenInputData().b2cYN === "Y") {
                $(".cp-box.lge-before").each(function () {
                    oCouponId.push($(this).closest("li").attr("data-coupon-id"));
                });
            } else {
                $(".cp-box.business-before").each(function () {
                    oCouponId.push($(this).closest("li").attr("data-coupon-id"));
                });
            }

            if (oCouponId.length === 0) {
                var obj = {title: ""};
                obj = $.extend(obj, {title: "다운로드할 수 있는 쿠폰이 없습니다."});
                lgkorUI.alert(null, obj);
                return;
            }

            var param = {};
            param.couponId = oCouponId;
            param.userId = vcui.Cookie.get("UNIFY_ID");
            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                    if (result.resultCode === "success") {
                        //success
                        var obj = {title: ""};
                        obj = $.extend(obj, {title: "다운로드 가능한 모든 쿠폰을<br/>다운받았습니다."});
                        lgkorUI.alert(null, obj);

                        this.requestPdpCoupon();
                    } else {
                        //fail
                        var obj = {title: ""};
                        obj = $.extend(obj, {title: result.errorMsg});
                        lgkorUI.alert(null, obj);
                    }
                }.bind(this),
                true,
                true
            );
        },
        /**
         * @method renderCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 쿠폰 리스트 호출]
         */
        renderCounponList: function () {
            if (this.variable.couponCnt === 0) {
                //no Data
                this.$couponWrap.hide();
            } else {
                this.$couponWrap.show();
                // this.$popCouponList.empty();
                this.$popCouponB2cArea.find('.coupon-list').empty();

                for (var i = 0; i < this.variable.couponCnt; i++) {
                    var item = this.variable.couponList[i];

                    if (item.cpDiscPrice === 0) {
                        item._cpDiscVal = item.cpDiscRate;
                        item._cpDiscUnit = "%";
                    } else {
                        item._cpDiscVal = vcui.number.addComma(item.cpDiscPrice);
                        item._cpDiscUnit = "원";
                    }

                    if (item.cpPublEdDate) {
                        var edDate = item.cpPublEdDate.replace(/-/gi, "/");

                        item._cpPublEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                        item._cpPublEdDate = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublEdDay = "";
                        item._cpPublEdDate = "";
                    }

                    if (item.cpPublStDate) {
                        var stDate = item.cpPublStDate.replace(/-/gi, "/");

                        item._cpPublStDate = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublStDate = "";
                    }

                    //BTOCSITE-21663 유효기간 추가
                    if (item.cpPeriodStData) {
                        var stDate = item.cpPeriodStData.replace(/-/gi, "/");

                        item._cpPeriodStData = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPeriodStData = "";
                    }

                    if (item.cpPeriodEdData) {
                        var edDate = item.cpPeriodEdData.replace(/-/gi, "/");

                        item._cpPeriodEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                        item._cpPeriodEdData = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPeriodEdDay = "";
                        item._cpPeriodEdData = "";
                    }

                    /* BTOCSITE-18919	PDP 쿠폰 다운로드 팝업 내 다운로드 받은 쿠폰 중복 노출 */
                    if (lgkorUI.getHiddenInputData().b2cYN === "Y") {
                        if (item.ordFlag === "A") {
                            item._state = "lge-before";
                        } else {
                            item._state = "lge-after";
                        }
                    } else {
                        item._state = "";
                    }
                    item._leftDayCnt = String(item.leftDayCnt);
                    item._cpDiscMinPrice = vcui.number.addComma(item.cpDiscMinPrice);
                    item._cpDiscMaxPrice = vcui.number.addComma(item.cpDiscMaxPrice);

                    //BTOCSITE-48266 [상품] B2B OBS 구축
                    if (lgkorUI.getHiddenInputData().b2cYN === "N") {

                        if (item.ordFlag === "A") {
                            item._b2bCouponClass = "business-before";
                        } else {
                            item._b2bCouponClass = "business-after";
                        }
                    } else {
                        item._b2bCouponClass = "";
                    }

                    /* BTOCSITE-18919	PDP 쿠폰 다운로드 팝업 내 다운로드 받은 쿠폰 중복 노출 */
                    if (item.ordFlag === "A") {
                        var replaceTemplate = vcui.template(couponItemTemplate, item);
                        replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br/&gt;", "<br>", false);
                        this.$popCouponB2cArea.find('.coupon-list.downloadable').append(replaceTemplate);
                    } else {
                        var replaceTemplate = vcui.template(couponItemTemplate, item);
                        replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br/&gt;", "<br>", false);
                        this.$popCouponB2cArea.find('.coupon-list.available').append(replaceTemplate);
                    }
                }
            }
        },
        // BTOCSITE-57394 임직원몰 / 계열사/ 복지몰 쿠폰
        /**
         * @method renderPartnerCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 임직원/복지몰 쿠폰 리스트 호출]
         */
        renderPartnerCounponList: function () {
            if (this.variable.partnerCouponCnt > 0) {
                this.$popCouponPartnerArea.find('.coupon-list').empty();

                for (var i = 0; i < this.variable.partnerCouponCnt; i++) {
                    var item = this.variable.partnerCouponList[i];

                    if (item.cpDiscPrice === 0) {
                        item._cpDiscVal = item.cpDiscRate;
                        item._cpDiscUnit = "%";
                    } else {
                        item._cpDiscVal = vcui.number.addComma(item.cpDiscPrice);
                        item._cpDiscUnit = "원";
                    }

                    if (item.cpPublEdDate) {
                        var edDate = item.cpPublEdDate.replace(/-/gi, "/");

                        item._cpPublEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                        item._cpPublEdDate = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublEdDay = "";
                        item._cpPublEdDate = "";
                    }

                    if (item.cpPublStDate) {
                        var stDate = item.cpPublStDate.replace(/-/gi, "/");

                        item._cpPublStDate = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublStDate = "";
                    }

                    //BTOCSITE-21663 유효기간 추가
                    if (item.cpPeriodStData) {
                        var stDate = item.cpPeriodStData.replace(/-/gi, "/");

                        item._cpPeriodStData = vcui.date.format(new Date(stDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPeriodStData = "";
                    }

                    if (item.cpPeriodEdData) {
                        var edDate = item.cpPeriodEdData.replace(/-/gi, "/");

                        item._cpPeriodEdDay = vcui.date.format(new Date(edDate), "yyyy년 M월 d일");
                        item._cpPeriodEdData = vcui.date.format(new Date(edDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPeriodEdDay = "";
                        item._cpPeriodEdData = "";
                    }

                    /* BTOCSITE-18919	PDP 쿠폰 다운로드 팝업 내 다운로드 받은 쿠폰 중복 노출 */
                    if (lgkorUI.getHiddenInputData().b2cYN === "Y") {
                        if (item.ordFlag === "A") {
                            item._state = "lge-before";
                        } else {
                            item._state = "lge-after";
                        }
                    } else {
                        item._state = "";
                    }
                    item._leftDayCnt = String(item.leftDayCnt);
                    item._cpDiscMinPrice = vcui.number.addComma(item.cpDiscMinPrice);
                    item._cpDiscMaxPrice = vcui.number.addComma(item.cpDiscMaxPrice);
                    item._b2bCouponClass = "";


                    /* BTOCSITE-18919	PDP 쿠폰 다운로드 팝업 내 다운로드 받은 쿠폰 중복 노출 */
                    if (item.ordFlag === "A") {
                        var replaceTemplate = vcui.template(couponItemTemplate, item);
                        replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br/&gt;", "<br>", false);
                        this.$popCouponPartnerArea.find('.coupon-list.downloadable').append(replaceTemplate);
                    } else {
                        var replaceTemplate = vcui.template(couponItemTemplate, item);
                        replaceTemplate = vcui.string.replaceAll(replaceTemplate, "&lt;br/&gt;", "<br>", false);
                        this.$popCouponPartnerArea.find('.coupon-list.available').append(replaceTemplate);
                    }
                }
            }
        },
        /**
         * @method renderBeautyCouponList
         * @return {myCallback} [프라엘 뷰티앱 쿠폰 : 특정 파라미터를 가진 URL로 접근시 쿠폰 팝업 기능 개발]
         */
        renderBeautyCouponList: function () {
            //  /beauty-devices/blp1?eventcode=beautyapp
            //  /beauty-devices/bbp1?eventcode=beautyapp
            //  /beauty-devices/bcp2a?eventcode=beautyapp
            //  /beauty-devices/bcp1a?eventcode=beautyapp
            var pathname = $(location).attr('pathname');

            if (pathname == '/beauty-devices/blp1' || pathname == '/beauty-devices/bbp1' || pathname == '/beauty-devices/bcp2a' || pathname == '/beauty-devices/bcp1a') {
                var evtParam = location.search;
                var couponPopWrap = $('.popup-wrap.copuon-pop-wrap');
                var couponPop = couponPopWrap.find('.coupon-down-pop');
                var popTit = couponPopWrap.find('.pop-header h1');
                var popTxt = couponPop.find('.bullet-list');
                var popFooter = couponPopWrap.find('.pop-footer');
                var couponArea = couponPop.find('.coupon-list').eq(0);

                if (evtParam == '?eventcode=beautyapp') {
                    this.$couponWrap.find('.coupon-btn button').trigger('click');
                    couponPopWrap.addClass('beauty-event');
                    popTit.html("<span>케어앱 고객을 위한 특별 할인 쿠폰</span>");
                    popTxt.removeClass('top-border');
                    popTxt.html("<li class='b-txt'>특별 할인 쿠폰은 발급일로부터 7일 이내 사용 가능합니다.</li><li class='b-txt'>지급된 쿠폰은 마이페이지 > 쿠폰함에서 확인 가능합니다.</li>");
                    popFooter.remove();
                    couponPopWrap.find(".sub-title").remove();
                    couponPop.find('.coupon-list').eq(1).remove();
                    couponArea.html(
                        '<li data-coupon-id="CL1D2206001">' +
                        '<div class="cp-box lge-before">' +
                        '<div class="cp-cont">' +
                        '<em class="title">30,000<i class="unit">원</i></em>' +
                        '<p class="description">프라엘케어 전용 인텐시브 멀티케어 할인 쿠폰</p>' +
                        '<div class="info">' +
                        '<p>2022년 6월 30일 종료(38일전)</p>' +
                        '</div>' +
                        '<div class="cp-btn">' +
                        '<button type="button" class="download"><em>다운로드</em></button>' +
                        '</div>' +
                        '</div>' +
                        '<div class="cp-open-view">' +
                        '<a href="#n" class="text">상세정보</a>' +
                        '<div class="cp-cont-view">' +
                        '<strong class="sub-tit">발급기간</strong>' +
                        '<div class="sub-cont">2022년 6월 9일 11:00 부터 <br>2022년 6월 30일 23:59 까지</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</li>' +
                        '<li data-coupon-id="CL1D2206003">' +
                        '<div class="cp-box lge-before">' +
                        '<div class="cp-cont">' +
                        '<em class="title">20,000<i class="unit">원</i></em>' +
                        '<p class="description">프라엘케어 전용 에센셜 부스터 할인 쿠폰</p>' +
                        '<div class="info">' +
                        '<p>2022년 6월 30일 종료(38일전)</p>' +
                        '</div>' +
                        '<div class="cp-btn">' +
                        '<button type="button" class="download"><em>다운로드</em></button>' +
                        '</div>' +
                        '</div>' +
                        '<div class="cp-open-view">' +
                        '<a href="#n" class="text">상세정보</a>' +
                        '<div class="cp-cont-view">' +
                        '<strong class="sub-tit">발급기간</strong>' +
                        '<div class="sub-cont">2022년 6월 9일 11:00 부터 <br>2022년 6월 30일 23:59 까지</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</li>' +
                        '<li data-coupon-id="CL1D2206002">' +
                        '<div class="cp-box lge-before">' +
                        '<div class="cp-cont">' +
                        '<em class="title">10,000<i class="unit">원</i></em>' +
                        '<p class="description">프라엘케어 전용 워시팝 할인 쿠폰</p>' +
                        '<div class="info">' +
                        '<p>2022년 6월 30일 종료(38일전)</p>' +
                        '</div>' +
                        '<div class="cp-btn">' +
                        '<button type="button" class="download"><em>다운로드</em></button>' +
                        '</div>' +
                        '</div>' +
                        '<div class="cp-open-view">' +
                        '<a href="#n" class="text">상세정보</a>' +
                        '<div class="cp-cont-view">' +
                        '<strong class="sub-tit">발급기간</strong>' +
                        '<div class="sub-cont">2022년 6월 9일 11:00 부터 <br>2022년 6월 30일 23:59 까지</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</li>'
                    );
                    couponPopWrap.find('.btn-close').click(function () {
                        history.replaceState({}, null, location.pathname);
                        location.reload();
                    })
                }
            }
        },
        /* //BTOCSITE-15679	특정 파라미터를 가진 URL로 접근시 쿠폰 팝업 기능 개발 */
        /**
         * @method goLogin
         * @return {myCallback} [로그인 화면으로 이동]
         */
        goLogin: function () {
            var obj = {title: ""};
            obj = $.extend(obj, {
                title: "로그인 후 받으실 수 있습니다.",
                ok: function () {
                    location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
                },
            });

            lgkorUI.alert(null, obj);
        },
        /* //BTOCSITE-24965 멤버십쿠폰 추가 */
        /**
         * @method requestPdpMeberShipCoupon
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 멤버십 쿠폰 리스트 ajax 호출 ]
         */
        requestPdpMeberShipCoupon: function () {
            var ajaxUrl = this.el.$pdpInfo.attr("data-mbs-coupon-list-ajax");
            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            var modelGubun = '';
            if (productInfo != null) {
                modelGubun = productInfo.model_gubun;
            }
            var param = {};
            param.prodCd = lgePdpSendData.sku;

            var $couponBtnDiv = $('.price-detail-item.coupon-detail-item .coupon-detail').not('.employee-disp'); // 쿠폰 버튼 생성 영역
            var $couponBtn = $('.price-detail-item.coupon-detail-item .coupon-detail').find('button[data-member-type!=employee]'); // 쿠폰 버튼
            var $popFooterBtn = $('.popup-wrap.copuon-pop-wrap').find('.pop-footer button'); // 팝업 내 쿠폰모두받기 버튼
            
            // 비로그인 시, 일반제품 외의 제품일 시, B2B일 시 멤버십쿠폰 호출하지 않음
            if (!lgkorUI.stringToBool(loginFlag) || lgePdpSendData.bizTypeDetail !== 'PRODUCT' || lgkorUI.getHiddenInputData().b2cYN === "N") {
                if (this.$popCouponB2cArea.find('.coupon-list.available').find("li").length === 0) {
                    this.$popCouponB2cArea.find('.sub-title.available').hide();
                    this.$popCouponB2cArea.find('.coupon-list.available').hide();
                } else {
                    this.$popCouponB2cArea.find('.sub-title.available').show();
                    this.$popCouponB2cArea.find('.coupon-list.available').show();
                }

                if (this.$popCouponB2cArea.find('.coupon-list.downloadable').find("li").length === 0) {
                    this.$popCouponB2cArea.find('.sub-title.downloadable').remove();
                    this.$popCouponB2cArea.find('.coupon-list.downloadable').remove();
                    $couponBtn.text("쿠폰 확인");
                    $couponBtn.removeClass("is-download-ico");
                    $couponBtn.removeClass("btn-coupon2");
                    $couponBtn.addClass("btn-coupon");
                }

                if (this.$popCouponB2cArea.find('.coupon-list.downloadable').find("li").length === 0 && this.$popCouponB2cArea.find('.coupon-list.available').find("li").length === 0) {
                    this.$popCouponB2cArea.html('<p class="no-data-coupon">사용 가능하거나 다운로드 가능한<br>쿠폰이 없습니다.</p>');
                }

                //쿠폰 show
                $couponBtnDiv.show();

                // 임직원 or 복지몰인 경우 해당 탭 영역 처리
                if (this.variable.isEmployee && this.$popCouponPartnerArea.length > 0 ) {

                    let $couponBtnEmployee = $('.price-detail-item.coupon-detail-item .coupon-detail').find('button[data-member-type=employee]');
                    let $maxPriceCouponEmployee = $('.price-detail-item.coupon-detail-item.employee-disp'); // 쿠폰 적용 내역 (적용쿠폰 전체영역)

                    if (this.$popCouponPartnerArea.find('.coupon-list.available').find("li").length === 0) {
                        this.$popCouponPartnerArea.find('.sub-title.available').hide();
                        this.$popCouponPartnerArea.find('.coupon-list.available').hide();
                    } else {
                        this.$popCouponPartnerArea.find('.sub-title.available').show();
                        this.$popCouponPartnerArea.find('.coupon-list.available').show();
                        $maxPriceCouponEmployee.show();
                    }
                    // 다운로드 가능한 쿠폰이 없을 경우
                    if (this.$popCouponPartnerArea.find('.coupon-list.downloadable').find("li").length === 0) {
                        this.$popCouponPartnerArea.find('.sub-title.downloadable').remove();
                        this.$popCouponPartnerArea.find('.coupon-list.downloadable').remove();
                        $couponBtnEmployee.text("쿠폰 확인");
                        $couponBtnEmployee.removeClass("is-download-ico");
                        $couponBtnEmployee.removeClass("btn-coupon2");
                        $couponBtnEmployee.addClass("btn-coupon");
                    }

                    if (this.$popCouponPartnerArea.find('.coupon-list.downloadable').find("li").length === 0 && this.$popCouponPartnerArea.find('.coupon-list.available').find("li").length === 0) {
                        this.$popCouponPartnerArea.html('<p class="no-data-coupon">사용 가능하거나 다운로드 가능한<br>쿠폰이 없습니다.</p>');
                    }
                }

                // 다운로드 가능한 쿠폰이 없을 경우 (B2B 포함)
                if ($(".cp-box.lge-before").length === 0 && $(".cp-box.business-before").length === 0) {
                    $popFooterBtn.hide();
                }

                return;
            }

            lgkorUI.requestAjaxDataPost(
                ajaxUrl,
                param,
                function (result) {
                    if (result.resultCode === "success" && result !== null) {
                        this.variable.mbsCouponCnt = result.totalCount;
                        this.variable.mbsCouponList = result.data;

                        this.sortMbsCounponList(); // 종료일 내림차순으로 정렬
                        this.renderMbsCounponList();

                        if (this.$popCouponB2cArea.find('.coupon-list.available').find("li").length === 0) {
                            this.$popCouponB2cArea.find('.sub-title.available').hide();
                            this.$popCouponB2cArea.find('.coupon-list.available').hide();
                        } else {
                            this.$popCouponB2cArea.find('.sub-title.available').show();
                            this.$popCouponB2cArea.find('.coupon-list.available').show();
                        }
                        // 다운로드 가능한 쿠폰이 없을 경우
                        if (this.$popCouponB2cArea.find('.coupon-list.downloadable').find("li").length === 0) {
                            this.$popCouponB2cArea.find('.sub-title.downloadable').remove();
                            this.$popCouponB2cArea.find('.coupon-list.downloadable').remove();
                            $couponBtn.text("쿠폰 확인");
                            $couponBtn.removeClass("is-download-ico");
                            $couponBtn.removeClass("btn-coupon2");
                            $couponBtn.addClass("btn-coupon");
                        }
                        //기존 상품 쿠폰이 없고 멤버십쿠폰은 있으면 & 멤버십쿠폰이 있고 사용하지 않은 쿠폰이면
                        if ((this.variable.couponCnt === 0 && this.variable.mbsCouponCnt > 0) && (this.variable.mbsCouponCnt > this.variable.useMbsCouponCnt)) {

                            if (modelGubun == "일반제품" || modelGubun == "케어솔루션") {
                                this.$couponPriceArea.hide();// 쿠폰할인가
                                $('#couponDiscountPrice').hide(); // 할인 / 혜택 내용보기 > 쿠폰할인
                                $('.coupon-detail-item').not('.employee-disp').show();// 쿠폰적용내역 영역
                            }

                            var $maxPriceCoupon = $('.price-detail-item.coupon-detail-item').not('.employee-disp');
                            var $maxPriceCouponText = $('.coupon-detail-item .text span').not('.employee-disp');
                            var $maxPriceCouponPrice = $('.coupon-detail-item .content span').not('.employee-disp');
                            $maxPriceCouponText.text('사용할 수 있는 쿠폰이 있습니다.');
                            $maxPriceCouponPrice.text('');
                            $maxPriceCoupon.show();
                        }
                        $couponBtnDiv.show();
                    } else {
                        if (this.$popCouponB2cArea.find('.coupon-list.available').find("li").length === 0) {
                            this.$popCouponB2cArea.find('.sub-title.available').hide();
                            this.$popCouponB2cArea.find('.coupon-list.available').hide();
                        } else {
                            this.$popCouponB2cArea.find('.sub-title.available').show();
                            this.$popCouponB2cArea.find('.coupon-list.available').show();
                        }
                        // 다운로드 가능한 쿠폰이 없을 경우
                        if (this.$popCouponB2cArea.find('.coupon-list.downloadable').find("li").length === 0) {
                            this.$popCouponB2cArea.find('.sub-title.downloadable').remove();
                            this.$popCouponB2cArea.find('.coupon-list.downloadable').remove();
                            $couponBtn.text("쿠폰 확인");
                            $couponBtn.removeClass("is-download-ico");
                            $couponBtn.removeClass("btn-coupon2");
                            $couponBtn.addClass("btn-coupon");
                        }
                    }

                    if (this.$popCouponB2cArea.find('.coupon-list.downloadable').find("li").length === 0 && this.$popCouponB2cArea.find('.coupon-list.available').find("li").length === 0) {
                        this.$popCouponB2cArea.html('<p class="no-data-coupon">사용 가능하거나 다운로드 가능한<br>쿠폰이 없습니다.</p>');
                    }

                    // 임직원 or 복지몰인 경우 해당 탭 영역 처리
                    if (this.variable.isEmployee && this.$popCouponPartnerArea.length > 0) {
                        let $couponBtnEmployee = $('.price-detail-item.coupon-detail-item .coupon-detail').find('button[data-member-type=employee]');
                        let $maxPriceCouponEmployee = $('.price-detail-item.coupon-detail-item.employee-disp'); // 쿠폰 적용 내역

                        if (this.$popCouponPartnerArea.find('.coupon-list.available').find("li").length === 0) {
                            this.$popCouponPartnerArea.find('.sub-title.available').hide();
                            this.$popCouponPartnerArea.find('.coupon-list.available').hide();
                        } else {
                            this.$popCouponPartnerArea.find('.sub-title.available').show();
                            this.$popCouponPartnerArea.find('.coupon-list.available').show();
                            $maxPriceCouponEmployee.show();
                        }

                        // 다운로드 가능한 쿠폰이 없을 경우
                        if (this.$popCouponPartnerArea.find('.coupon-list.downloadable').find("li").length === 0) {
                            this.$popCouponPartnerArea.find('.sub-title.downloadable').remove();
                            this.$popCouponPartnerArea.find('.coupon-list.downloadable').remove();
                            $couponBtnEmployee.text("쿠폰 확인");
                            $couponBtnEmployee.removeClass("is-download-ico");
                            $couponBtnEmployee.removeClass("btn-coupon2");
                            $couponBtnEmployee.addClass("btn-coupon");
                        }

                        //기존 상품 쿠폰이 없고 멤버십쿠폰은 있으면 & 멤버십쿠폰이 있고 사용하지 않은 쿠폰이면
                        if ((this.variable.partnerCouponCnt === 0 && this.variable.mbsCouponCnt > 0) && (this.variable.mbsCouponCnt > this.variable.useMbsCouponCnt)) {
                            if (modelGubun == "일반제품" || modelGubun == "케어솔루션") {
                                $('#employeeTabCouponPrice').hide();// 쿠폰할인가
                                $('.coupon-detail-item.employee-disp').show();// 쿠폰정보
                            }

                            let $maxPriceCouponTextEmployee = $('.coupon-detail-item .text span.employee-disp'); // 쿠폰 명
                            let $maxPriceCouponPriceEmployee = $('.coupon-detail-item .content span.employee-disp');// 쿠폰 금액

                            $maxPriceCouponTextEmployee.text('사용할 수 있는 쿠폰이 있습니다.');
                            $maxPriceCouponPriceEmployee.text('');
                            $maxPriceCouponEmployee.show();
                        }

                        if (this.$popCouponPartnerArea.find('.coupon-list.downloadable').find("li").length === 0 && this.$popCouponPartnerArea.find('.coupon-list.available').find("li").length === 0) {
                            this.$popCouponPartnerArea.html('<p class="no-data-coupon">사용 가능하거나 다운로드 가능한<br>쿠폰이 없습니다.</p>');
                        }
                    }

                    if ($(".cp-box.lge-before").length === 0) {
                        $popFooterBtn.hide();
                    }

                }.bind(this),
                true,
                true
            );
        },
        /* //BTOCSITE-24965 멤버십쿠폰 추가 (리스트 정렬) */
        /**
         * @method sortMbsCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 멤버십 쿠폰 리스트 호출]
         */
        sortMbsCounponList: function () {
            try {
                var sorted_list = this.variable.mbsCouponList.sort(function (a, b) {
                    var aDate = '';
                    var bDate = '';
                    if (a.endDateTime) {
                        var aYear = a.endDateTime.substr(0, 4);
                        var aMonth = a.endDateTime.substr(4, 2);
                        var aDay = a.endDateTime.substr(6, 2);
                        var aHH = a.endDateTime.substr(8, 2);
                        var aMM = a.endDateTime.substr(10, 2);
                        var aSS = a.endDateTime.substr(12);
                        aDate = aYear + "-" + aMonth + "-" + aDay + " " + aHH + ":" + aMM + ":" + aSS;
                    }
                    if (b.endDateTime) {
                        var bYear = b.endDateTime.substr(0, 4);
                        var bMonth = b.endDateTime.substr(4, 2);
                        var bDay = b.endDateTime.substr(6, 2);
                        var bHH = b.endDateTime.substr(8, 2);
                        var bMM = b.endDateTime.substr(10, 2);
                        var bSS = b.endDateTime.substr(12);
                        bDate = bYear + "-" + bMonth + "-" + bDay + " " + bHH + ":" + bMM + ":" + bSS;
                    }
                    return new Date(aDate).getTime() - new Date(bDate).getTime();
                });
            } catch (err) {
                return;
            }
        },
        /* //BTOCSITE-24965 멤버십쿠폰 추가 */
        /**
         * @method renderMbsCounponList
         * @return {myCallback} [사용할 수 있는쿠폰 팝업 > 멤버십 쿠폰 리스트 호출]
         */
        renderMbsCounponList: function () {
            if (this.variable.couponCnt === 0 && this.variable.mbsCouponCnt === 0) {
                //no Data
                this.$couponWrap.hide();
            } else {
                this.$couponWrap.show();
                if (this.variable.couponCnt === 0) {
                    //	this.$popCouponList.empty();
                    this.$popCouponB2cArea.find('.coupon-list').empty();
                }

                for (var i = 0; i < this.variable.mbsCouponCnt; i++) {
                    var item = this.variable.mbsCouponList[i];

                    if (item.couponType === "RATE") { // (정률:RATE,정액:PRICE)
                        item._cpDiscVal = item.couponAmt;
                        item._cpDiscUnit = "%";
                    } else {
                        item._cpDiscVal = vcui.number.addComma(item.couponAmt);
                        item._cpDiscUnit = "원";
                    }
                    var eDate = "";
                    if (item.endDateTime) {
                        eDate = vcui.date.parse(item.endDateTime);

                        item._cpPublEdDay = vcui.date.format(new Date(eDate), "yyyy년 M월 d일");
                        item._cpPublEdDate = vcui.date.format(new Date(eDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublEdDay = "";
                        item._cpPublEdDate = "";
                    }

                    if (item.startDateTime) {
                        sDate = vcui.date.parse(item.startDateTime);

                        item._cpPublStDate = vcui.date.format(new Date(sDate), "yyyy년 M월 d일 hh:mm");
                    } else {
                        item._cpPublStDate = "";
                    }

                    var today = new Date();
                    var diffDate = vcui.date.diff(new Date, eDate);
                    item._leftDayCnt = diffDate.days;
                    if (item._leftDayCnt < 1) {
                        item._leftDayCnt = 0;
                    }

                    if (item.useYn === "Y" || item._leftDayCnt < 0) { // 사용하거나 만료된 쿠폰이면 보이지 않는다.
                        this.variable.useMbsCouponCnt++;
                        continue;
                    }

                    if (item.couponAmtMin && item.couponAmtMin > 1) {
                        item._cpDiscMinPrice = vcui.number.addComma(item.couponAmtMin);
                    } else {
                        item._cpDiscMinPrice = "";
                    }
                    if (item.couponAmtMax && item.couponAmtMax > 1) {
                        item._cpDiscMaxPrice = vcui.number.addComma(item.couponAmtMax);
                    } else {
                        item._cpDiscMaxPrice = "";
                    }

                    //BTOCSITE-48266 [상품] B2B OBS 구축
                    if (lgkorUI.getHiddenInputData().b2cYN === "N") {
                        if (item.ordFlag === "A") {
                            item._b2bCouponClass = "business-before";
                        } else {
                            item._b2bCouponClass = "business-after";
                        }
                    } else {
                        item._b2bCouponClass = "";
                    }

                    //멤버십 쿠폰은 사용 가능한 쿠폰. (굳이 다운받지 않아도됨)
                    this.$popCouponB2cArea.find('.coupon-list.available').append(vcui.template(mbsCouponItemTemplate, item));

                    // 임직원 or 복지몰인 경우 해당 탭 영역 내에도 멤버십 쿠폰 노출
                    if (this.variable.isEmployee && this.$popCouponPartnerArea.length > 0 ) {
                        this.$popCouponPartnerArea.find('.coupon-list.available').append(vcui.template(mbsCouponItemTemplate, item));
                    }
                }
            }
        },
        //BTOCSITE-35421 최대 혜택영역 쿠폰 버튼 이벤트
        benefitAreaInit: function () {
            //쿠폰 버튼 이벤트 등록
            this.$couponDetail.on("click", "button", $.proxy(this.handler.couponInit, this));
        },

        //BTOCSITE-35421 비로그인시
        beforeloginCouponeInit: function (obsTotCouponDiscountPrice, apprDateDiscountPrice) {

            var productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
            var modelGubun = '';
            if (productInfo != null) {
                modelGubun = productInfo.model_gubun;
            }

            if (modelGubun == "일반제품" || modelGubun == "케어솔루션") {
                var inputdata = this.variable.inpData;
                // 캐시백
                var rewardAmt = !vcui.isEmpty(inputdata.rewardAmt) && inputdata.rewardAmt !== "0" ? vcui.number.parse(inputdata.rewardAmt) : 0;
                //결제일할인금액
                if (apprDateDiscountPrice == undefined) {
                    apprDateDiscountPrice = !vcui.isEmpty(inputdata.apprDateDiscountPrice) && inputdata.apprDateDiscountPrice !== "0" ? vcui.number.parse(inputdata.apprDateDiscountPrice) : 0;
                }

                if (!lgkorUI.stringToBool(loginFlag) && (obsTotCouponDiscountPrice == "" || obsTotCouponDiscountPrice== undefined) ) {
                    if (rewardAmt > 0 || apprDateDiscountPrice > 0) {
                        $('#benefitPriceBeforelogin').show();
                    } else {
                        $('#benefitPriceBeforelogin').hide();
                    }
                } else {
                    $('#benefitPriceBeforelogin').hide();
                }
            }
        },

        //BTOCSITE-48266 b2b 사업자회원가 가져오기 로그인 데이타 정보 가져오기
        getB2bBusinessPrice: function () {
            var ajaxUrl = "/mkt/ajax/product/b2bBusinessPrice"

            var param = {
                modelId: lgePdpSendData.modelId
            }

            let priceData = "";
            $.ajax({
                url: ajaxUrl,
                type: "POST",
                data: param,
                async: false,
                success: function (result) {

                    if (result.status === "success") {
                        priceData = result
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });

            //시업자 회원만 쿠폰 정보를 호출한다.
            if (!vcui.isEmpty(priceData) && priceData.data.memberPartnerGrp === "ENT") {
                pdpCoupon.variable.partnerPrice = priceData.data.partnerPrice;
                this.requestPdpCoupon();
            }
        }
    };

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'PROD', name: 'KRP0008-coupon', isFirstLoad: true, fn: function () {
                pdpCoupon.init(".pdp-info-area");
            }
        });
    }

    // BTOCSITE-70412 START
    function updateNewestPrice() {
        let pdpInfoPaymentAmountObject = $('div.pdp-info-area .payment-amount');
        pdpInfoPaymentAmountObject.each(function(index,item){
            if ($('div.pdp-info-area .payment-amount input.quantity').length > 0) {
                if ($('div.pdp-info-area .payment-amount input.quantity').val() > 1) {
                    _KRP0008.updatePaymentAmountPrice($(item), true);
                } else {
                    _KRP0008.updatePaymentAmountPrice($(item));
                }
            } else {
                _KRP0008.updatePaymentAmountPrice($(item));
            }
        });
    }
    // BTOCSITE-70412 END

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function () {
        SAVE_COMPONENT_PDP_DOM_MNG();
    });

    return {
         KRP0008_COUPON_INIT : function(){
             pdpCoupon.init(".pdp-info-area");
         }
    }
})();
